import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import { CustomDeleteIcon as DeleteSvgIcon } from "../svg-icons/material-icons";

type DeleteIconProps = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  tooltip?: string;
  iconColor?: string;
} & IconButtonProps;

const DISABLED_FILL = "#BDBDBD";

const DeleteIcon = ({
  onClick,
  tooltip,
  iconColor,
  disabled,
  ...others
}: DeleteIconProps) => {
  const button = (
    <IconButton onClick={onClick} disabled={disabled} {...others}>
      <DeleteSvgIcon fill={disabled ? DISABLED_FILL : iconColor} />
    </IconButton>
  );

  if (!tooltip) return button;
  return (
    <Tooltip title={tooltip}>
      <span style={{ display: "inline-flex" }}>{button}</span>
    </Tooltip>
  );
};

export default DeleteIcon;
